import React, { useState, useRef, useEffect } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { Toast } from "primereact/toast";

import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { supplierservices } from "../../services/supplierServices";

import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import  { useLocation } from "react-router";
import {HandleClose} from '../../helpers/formclose';

function Editsupplier() {
  const location = useLocation(null);  
  const toast = useRef(null);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    shopname: "",
    type: "",
    photo: "",
    account_holder: "",
    account_number: "",
    bank_name: "",
    status:"",
    city:"",
    countrySubDivisionCode:"",
    postalCode:""
  });


  useEffect(()=>{
    console.log("location data");
    console.log(location.state?.supplier);
    setFormData(location.state?.supplier);
  },[]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const inputRefs = {
    name: useRef(null),
    email: useRef(null),
    phone: useRef(null),
    address: useRef(null),
    shopname: useRef(null),
    account_holder: useRef(null),
    account_number: useRef(null),
    bank_name: useRef(null),
};

const validateForm = () => {
  return true;
  // const newErrors = {};

  // if (!formData.name.trim()) {
  //   newErrors.name = "Name is required";
  // }

  // if (!formData.email.trim()) {
  //   newErrors.email = "Email is required";
  // }

  // if (!formData.phone.trim()) {
  //   newErrors.phone = "Phone is required";
  // }

  // if (!formData.address.trim()) {
  //   newErrors.address = "Address is required";
  // }

  // if (!formData.shopname.trim()) {
  //   newErrors.shopname = "Shop Name is required";
  // }

  // if (!formData.account_holder.trim()) {
  //   newErrors.account_holder = "Account Holder is required";
  // }

  // if (!formData.account_number.trim()) {
  //   newErrors.account_number = "Account Number is required";
  // }

  // if (!formData.bank_name.trim()) {
  //   newErrors.bank_name = "Bank Name is required";
  // }

  // // Add other validations here...

  // setErrors(newErrors);

  // // Focus first error field
  // const firstErrorKey = Object.keys(newErrors)[0];
  // if (firstErrorKey && inputRefs[firstErrorKey]) {
  //   inputRefs[firstErrorKey].current.focus();
  // }

  // return Object.keys(newErrors).length === 0;
};


  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
        supplierservices.editsupplier(formData).then((response)=>{
        if(response.status == 200){
            setFormData(formData);
            toast.current.show({ severity: 'success', summary: 'Supplier', detail: `${response.data.data}` });
                
        }else{
            toast.current.show({ severity: 'error', summary: 'Supplier', detail: `${response.data.data}` });     
        }
    }).catch((error)=>{
        toast.current.show({ severity: 'error', summary: 'Supplier', detail: 'Error' });     
    });
    console.log(formData); // You can send this to your API
  }

  };

  const handleClose = () => {
    // Reset form or close modal logic
    console.log('Form Closed');
  };

  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Supplier / UpdateSupplier"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}

        {/* <Titlebar text={"Edit Supplier"} /> */}
        <div className="col-md-12 mt-3">
          <div className="card ps-3 pe-3">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4">
                  <form onSubmit={handleSubmit} >
                    <div className="row">
                      {/* Name */}
                      <div className="col-md-6 form-group">
                        <Label name="Name" />
                        <input
                          type="text"
                          name="name"
                          className={`form-control ${errors.name ? "is-invalid" : ""}`}
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Enter Name"
                          ref={inputRefs.name}
                          required
                        />
                         {/* {errors.name && <div className="invalid-feedback">{errors.name}</div>} */}
                      </div>

                      {/* Email */}
                      <div className="col-md-6 form-group">
                        <Label name="Email" />
                        <input
                          type="email"
                          name="email"
                          className={`form-control ${errors.email ? "is-invalid" : ""}`}
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Enter Email"
                          ref={inputRefs.email}
                          required
                        />
                         {/* {errors.email && <div className="invalid-feedback">{errors.email}</div>} */}
                      </div>

                      {/* Phone */}
                      <div className="col-md-6 form-group">
                        <Label name="Phone" />
                        <input
                          type="tel"
                          name="phone"
                          className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="Enter Phone"
                          ref={inputRefs.phone}
                          required
                        />
                        {/* {errors.phone && <div className="invalid-feedback">{errors.phone}</div>} */}
                      </div>

                      {/* Address */}
                      <div className="col-md-6 form-group">
                        <Label name="Address" />
                        <input
                          type="text"
                          name="address"
                          className={`form-control ${errors.address ? "is-invalid" : ""}`}
                          value={formData.address}
                          onChange={handleChange}
                          placeholder="Enter Address"
                          ref={inputRefs.address}
                          required
                        />
                        {/* {errors.address && <div className="invalid-feedback">{errors.address}</div>} */}
                      </div>

                       <div className="col-md-6 form-group">
                         <Label name="City" />
                        <input
                          type="text"
                          name="city"
                          className="form-control"
                          value={formData.city}
                          onChange={handleChange}
                          placeholder="City"
                          required
                        />
                        {/* {errors.address && <span style={{ color: "red" }}>{errors.address}</span>} */}
                      </div>

                       <div className="col-md-6 form-group">
                        <Label name="Country SubDivision Code" />
                        <input
                          type="text"
                          name="countrySubDivisionCode"
                          className="form-control"
                          value={formData.countrySubDivisionCode}
                          onChange={handleChange}
                          placeholder="Country SubDivision Code"
                          required
                        />
                        {/* {errors.address && <span style={{ color: "red" }}>{errors.address}</span>} */}
                      </div>

                      <div className="col-md-6 form-group">
                        <Label name="PostalCode" />
                        <input
                          type="text"
                          name="postalCode"
                          className="form-control"
                          value={formData.postalCode}
                          onChange={handleChange}
                          placeholder="Postal Code"
                          required
                        />
                        {/* {errors.address && <span style={{ color: "red" }}>{errors.address}</span>} */}
                      </div>

                      {/* Shop Name */}
                      <div className="col-md-6 form-group">
                        <Label name="Shop Name" />
                        <input
                          type="text"
                          name="shopname"
                          className={`form-control ${errors.shopname ? "is-invalid" : ""}`}
                          value={formData.shopname}
                          onChange={handleChange}
                          placeholder="Enter Shop Name"
                          ref={inputRefs.shopname}
                          required
                        />
                        {/* {errors.shopname && <div className="invalid-feedback">{errors.shopname}</div>} */}
                      </div>

                      {/* Type */}
                      <div className="col-md-6 form-group">
                        <Label name="Type" />
                        <select
                          className={`form-control ${errors.type ? "is-invalid" : ""}`}
                          name="type"
                          value={formData.type}
                          onChange={handleChange}
                          // ref={inputRefs.type}
                          required
                        >
                          <option value="wholeseler">Whole Saler</option>
                          <option value="distributor">Distributor</option>
                          <option value="retailer">Retailer</option>
                          <option value="manufacturer">Manufacturer</option>
                        </select>
                         {/* {errors.type && <div className="invalid-feedback">{errors.type}</div>} */}
                      </div>

                      {/* Photo */}
                      <div className="col-md-6 form-group">
                        <label>Photo URL</label>
                        <input
                          type="text"
                          name="photo"
                          className="form-control"
                          value={formData.photo}
                          onChange={handleChange}
                          placeholder="Enter Photo URL"
                        />
                      </div>

                      {/* Account Holder */}
                      <div className="col-md-6 form-group">
                         <Label name="Account Holder" />
                        <input
                          type="text"
                          name="account_holder"
                          className={`form-control ${errors.account_holder ? "is-invalid" : ""}`}
                          value={formData.account_holder}
                          onChange={handleChange}
                          placeholder="Enter Account Holder"
                          required
                          // ref={inputRefs.account_holder}
                        />
                        {/* {errors.account_holder && <div className="invalid-feedback">{errors.account_holder}</div>} */}
                      </div>

                      {/* Account Number */}
                      <div className="col-md-4 form-group">
                        <Label name="Account Number" />
                        <input
                          type="text"
                          name="account_number"
                          className={`form-control ${errors.account_number ? "is-invalid" : ""}`}
                          value={formData.account_number}
                          onChange={handleChange}
                          placeholder="Enter Account Number"
                          ref={inputRefs.account_number}
                          required
                        />
                        {/* {errors.account_number && <div className="invalid-feedback">{errors.account_number}</div>} */}
                      </div>

                      {/* Bank Name */}
                      <div className="col-md-4 form-group">
                        <label>Bank Name</label>
                        <input
                          type="text"
                          name="bank_name"
                          className={`form-control ${errors.bank_name ? "is-invalid" : ""}`}
                          value={formData.bank_name}
                          onChange={handleChange}
                          placeholder="Enter Bank Name"
                          ref={inputRefs.bank_name}
                        />
                         {errors.bank_name && <div className="invalid-feedback">{errors.bank_name}</div>}
                      </div>

                      {/* Status */}
                      <div className="col-md-4 form-group">
                        <label>Status</label>
                        <select
                          className="form-control"
                          name="status"
                          value={formData.status}
                          onChange={handleChange}
                        >
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </select>
                      </div>

                      <div className="col-md-6 form-group">
                            {/* <label>Type</label> */}
                            <Label name="Category" />
                            <select className="form-control" name="category" value={formData.category}
                              onChange={handleChange} required>
                              <option value="inhouse">In House</option>
                              <option value="external">External</option>
                            </select>
    
                          </div>
                    </div>


                    <br></br>
                    {/* <br></br> */}
                    <div className="row">
                        <div className='col-md-6'>
                        <button
                        type="submit"
                        className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                        >
                        Save
                        </button>
                        </div>

                         {<HandleClose/>}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Editsupplier;
